import { ChangeEvent, FC, useEffect, useState } from 'react';
import qs from 'qs';
//import { useParams } from 'react-router-dom';
import { useBoolean } from 'hooks';
import { fetcher } from 'services';
import { getErrorMessageByStatusCode } from 'utils';
import { LkpChart } from 'components/Charts universal/Chart';
import { ChartsParamsType } from 'components/Charts universal/types';
import { LkpChartTopFilter } from 'components/Charts universal/Filters';
import { HeaderFiltersType } from 'context/GlobalFiltersContext/initialState';
export interface LkpChartNumberOccurrencesByPriorityProps {
  headerFilters: HeaderFiltersType;
  inicio?: string;
  fim?: string;
  sistemas?: any[];
  externalData?: any;
  externalLoading?: boolean;
  disableFetch?: boolean;
}
const LkpChartNumberOccurrencesByPriority: FC<LkpChartNumberOccurrencesByPriorityProps> = ({
  headerFilters,
  inicio,
  fim,
  sistemas,
  externalData,
  externalLoading = false,
  disableFetch = false,
}) => {
  const { value: isLoading, setValue: setLoading } = useBoolean();
  const isLoadingFinal = externalLoading || isLoading;
  //const { dateFrom, dateTo } = useParams<{ dateFrom: string; dateTo: string }>();
  const { value: isError, setValue: setIsError } = useBoolean();
  const [series, setSeries] = useState<any[]>([]);
  const [labels, setLabels] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [paramsSystems] = useState<string>('');
  const [params, setParams] = useState<ChartsParamsType>({
    Empresa: headerFilters?.companies?.id || 0,
    Sites: headerFilters?.units?.id,
    Inicio: inicio,
    Fim: fim,
    GrupoSite: headerFilters?.unitGroups?.id || [],
    SubGrupoSite: headerFilters?.unitSubgroups?.id || [],
    Cidade: headerFilters?.cities?.id || [],
    Estado: headerFilters?.states?.id || [],
    Sistemas: sistemas || [],
  });
  useEffect(() => {
    setParams(prev => ({
      ...prev,
      Empresa: headerFilters?.companies?.id || 0,
      Sites: headerFilters?.units?.id,
      GrupoSite: headerFilters?.unitGroups?.id || [],
      SubGrupoSite: headerFilters?.unitSubgroups?.id || [],
      Cidade: headerFilters?.cities?.id || [],
      Estado: headerFilters?.states?.id || [],
      Inicio: inicio,
      Fim: fim,
    }));
  }, [
    inicio,
    fim,
    sistemas,
    headerFilters?.companies?.id,
    headerFilters?.units?.id,
    headerFilters?.unitGroups?.id,
    headerFilters?.unitSubgroups?.id,
    headerFilters?.cities?.id,
    headerFilters?.states?.id,
  ]);
  const handleChangeStartDate = (event: ChangeEvent<HTMLInputElement>) => {
    const { value: Inicio } = event.target;
    setParams({ ...params, Inicio });
  };
  const handleChangeEndDate = (event: ChangeEvent<HTMLInputElement>) => {
    const { value: Fim } = event.target;
    setParams({ ...params, Fim });
  };
  const fetchChartData = async () => {
    setLoading(true);
    let _httpPath = '/ocorrencias-por-prioridade-por-periodo';
    if (!!paramsSystems) _httpPath = `${_httpPath}?Sistemas=${paramsSystems}`;
    const result = await fetcher
      .get<any[]>(_httpPath, 'dashboard', {
        params: {
          ...params,
          GrupoSite: headerFilters?.unitGroups?.id,
          SubGrupoSite: headerFilters?.unitSubgroups?.id,
          Cidade: headerFilters?.cities?.id,
          Estado: headerFilters?.states?.id,
        },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      })
      .catch(error => {
        const message = getErrorMessageByStatusCode(error, _httpPath);
        setErrorMessage(message);
        setIsError(true);
      });
    if (result) {
      setLabels(
        result.map(({ nome }) => {
          if (!nome) return 'Sem prioridade';
          return nome;
        }),
      );
      setSeries(result.map(({ quantidade }) => (typeof quantidade === 'string' ? parseInt(quantidade) : 0)));
    }
    setLoading(false);
  };
  useEffect(() => {
    if (disableFetch && externalData) {
      setLabels(
        externalData.map(({ nome }) => {
          if (!nome) return 'Sem prioridade';
          return nome;
        }),
      );
      setSeries(externalData.map(({ quantidade }) => (typeof quantidade === 'string' ? parseInt(quantidade) : 0)));
      return;
    }

    if (disableFetch) return;

    (async () => {
      await fetchChartData();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params?.Inicio,
    params?.Fim,
    headerFilters?.unitGroups?.id,
    headerFilters?.unitSubgroups?.id,
    headerFilters?.companies?.id,
    sistemas,
    headerFilters?.states?.id,
    headerFilters?.cities?.id,
    disableFetch,
    externalData,
  ]);
  return (
    <LkpChart
      title="Quantidade de ocorrências cadastradas por prioridade"
      type="donut"
      companyId={headerFilters?.companies?.id || 0}
      series={series}
      error={isError}
      //width={830}
      errorMessage={errorMessage}
      loading={isLoadingFinal}
      options={{
        labels,
        colors: ['#00C0C7', '#5144D3', '#E8871A', '#DA3490', '#9089FA', '#47E26F'],
        dataLabels: {
          formatter: function (value, { seriesIndex, w }) {
            return w?.config?.series?.[seriesIndex];
          },
        },
      }}
      filter={<LkpChartTopFilter onChangeStartDate={handleChangeStartDate} onChangeEndDate={handleChangeEndDate} />}
    ></LkpChart>
  );
};
export { LkpChartNumberOccurrencesByPriority };
